import { MigrationInterface, QueryRunner } from 'typeorm'

export class RefactorContactSettings1772265369873 implements MigrationInterface {
	name = 'RefactorContactSettings1772265369873'

	public async up(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "settings" ADD "restaurant" json`)

		// Copy contact data or set a default empty object for rows that didn't have contact data
		await queryRunner.query(`UPDATE "settings" SET "restaurant" = "contact" WHERE "contact" IS NOT NULL`)
		await queryRunner.query(`UPDATE "settings" SET "restaurant" = '{}' WHERE "restaurant" IS NULL`)

		await queryRunner.query(`ALTER TABLE "settings" ALTER COLUMN "restaurant" SET NOT NULL`)

		// Merge googleReservations into reservation column before dropping
		await queryRunner.query(`
			UPDATE "settings"
			SET "reservation" = jsonb_set(
				COALESCE("reservation"::jsonb, '{}'::jsonb),
				'{googleReservations}',
				COALESCE("googleReservations"::jsonb, 'null'::jsonb)
			)::json
			WHERE "googleReservations" IS NOT NULL
		`)

		await queryRunner.query(`ALTER TABLE "settings" DROP COLUMN "contact"`)
		await queryRunner.query(`ALTER TABLE "settings" DROP COLUMN "googleReservations"`)
	}

	public async down(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "settings" ADD "contact" json NOT NULL`)
		await queryRunner.query(`ALTER TABLE "settings" ADD "googleReservations" json`)

		// Restore googleReservations from reservation column
		await queryRunner.query(`
			UPDATE "settings"
			SET "googleReservations" = "reservation"->'googleReservations'
			WHERE "reservation"->'googleReservations' IS NOT NULL
		`)

		// Restore contact from restaurant column
		await queryRunner.query(`UPDATE "settings" SET "contact" = "restaurant"`)

		await queryRunner.query(`ALTER TABLE "settings" DROP COLUMN "restaurant"`)
	}
}
